import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ConditionGraphSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ConditionGraphSVG;
